import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../../html-sanitizer'

export const PDPBannerPromo = ({label, bodycopy}) => {
    const styles = useStyleConfig('PDPBannerPromo')

    return (
        <Flex {...styles.container} data-testid="pdp-banner-promo-container">
            <Flex {...styles.combo} data-testid="pdp-banner-promo-combo">
                {label && (
                    <Flex {...styles.label} data-testid="pdp-banner-promo-label">
                        {' '}
                        {label}
                    </Flex>
                )}
                {bodycopy && (
                    <SanitizedHtml
                        {...styles.bodycopy}
                        html={bodycopy}
                        data-testid="pdp-banner-promo-bodycopy"
                    />
                )}
            </Flex>
        </Flex>
    )
}

PDPBannerPromo.propTypes = {
    label: PropTypes.string,
    bodycopy: PropTypes.string,
}
